module.exports = __webpack_public_path__ + "img/1.0161f551.png";